import { createSlice } from "@reduxjs/toolkit";
import { getRequest } from "../../../services/apiCaller/cl_index";
import { endpoints } from "../../../api/ApiEndPoints";

const initialState={
    staticContent:''
}


export const topGamesListSlice=createSlice({
    name:'topGamesList',
    initialState,
    reducers:{
        setStaticContent:(state,action)=>{
            state.staticContent=action.payload
        }
    }
})

export const {setStaticContent}=topGamesListSlice.actions;


export const setTopGamesListContent=(brandid)=>(dispatch)=>{
    const url=endpoints.topGamesListStaticContent+`/${brandid}`;
    getRequest(url).then((res) => {
        if (res?.status === 200) {
          dispatch(setStaticContent(res?.data));
        }else{
          dispatch(setStaticContent([]))
        }
      });
}
export default topGamesListSlice.reducer;

